
import React from 'react';
import ReactDOM from "react-dom";

class CouponForm extends React.Component {

    constructor(props) {
        super(props);
        this.zipInput = React.createRef();
        this.emailInput = React.createRef();


        this.state = {
            campaignCode: 6,
            questionSelection: '',
            zip: '',
            email: '',
            questions: [],
            host: 'https://apps.skyharbor.com/ParkingCouponService/',
            errorMessage: '',
            qrCodeValue: '',
            validZip: true,
            validEmail: true,
            submitting: false,
            qrCodeHost: () => this.state.host + 'coupon/' + this.state.qrCodeValue,
            registerUrl: () => this.state.host + 'register/' + this.state.campaignCode,
            resendUrl: () => this.state.host + 'resend/' + this.state.campaignCode,
            questionsUrl: () => this.state.host + 'questions/' + this.state.campaignCode,

        };


        fetch(this.state.questionsUrl()).then(response => response.json()).then(jr => this.setState(Object.assign(this.state, {questions: jr})))
    }

    debouncedValidation = (func, wait, immediate) => {
        let timeout;
        return function () {
            let context = this, args = arguments;
            let later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            let callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    handleQustionSelection = (event) => {
        this.setState(Object.assign(this.state, {questionSelection: event.target.value}))

    };
    handleZipChange = this.debouncedValidation((event) => {
        //this.setState(Object.assign(this.state, {email: event.target.value}));
        const valid = /^[0-9]{4,10}$/.test(event);
        this.setState(Object.assign(this.state, {validZip: valid}, {zip: event}))
    }, 500, false);


    handleEmailChange = this.debouncedValidation((event) => {
        //this.setState(Object.assign(this.state, {email: event.target.value}));
        const valid = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,4}$/.test(event);
        this.setState(Object.assign(this.state, {validEmail: valid}, {email: event}));
    }, 500, false);


    handleJsonResponse = (response) => {


        //this.setState(Object.assign(this.state, {errorMessage: response.error}))

        this.setState(Object.assign(this.state, {errorMessage: response.error}, {qrCodeValue: response.data}));

    };
    submit = () => {

        fetch(this.state.registerUrl(), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({email: this.state.email, zipCode: this.state.zip, qr: this.state.questionSelection})
        }).then(response => response.json())
            .then(this.handleJsonResponse)
            .catch(e => {

            })

    };

    resend = () => {
        fetch(this.state.resendUrl(), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({email: this.state.email, zipCode: this.state.zip, qr: this.state.questionSelection})
        }).then(this.handleJsonResponse)
            .catch(e => {

            })
    };

    goBack = () => {
        this.setState(Object.assign(this.state, {
            errorMessage: '',
            qrCodeValue: ''
        }))
    };

    render() {
        return (
            <div className="App container-fluid">
                {this.state.qrCodeValue !== '' && this.state.errorMessage === '' ?

                    <div className="row align-items-center justify-content-around">

                        <div className="col-sm-12 text-center">
                            Thanks! Your coupon will be delivered to the email address provided.
                        </div>
                        <div className="col-sm-12 text-center ">
                            <button type="button" style={{backgroundColor: "#074973"}} className="btn btn-primary my-3" onClick={this.goBack}>Go Back
                            </button>
                        </div>
                    </div>
                    : null}
                {this.state.qrCodeValue === '' && this.state.errorMessage === '' ?
                    <form>

                        <div className=" form-row d-flex justify-content-center">

                            <div className=" form-group col-md-6">
                                <div className=" input-group mb-2">
                                    <div className=" input-group-prepend">
                                        <div className=" input-group-text">Zip Code</div>
                                    </div>
                                    <input ref={this.zipInput} type="text" disabled={this.state.submitting}
                                           onChange={(e) => this.handleZipChange(e.target.value)}
                                           className="form-control"/>
                                </div>
                                {this.state.validZip ? null : <span>Please Enter a valid Zip Code</span>}
                            </div>
                        </div>
                        <div className=" form-row d-flex justify-content-center">
                            <div className=" form-group col-md-6 ">
                                <div className=" input-group mb-2">
                                    <div className=" input-group-prepend">
                                        <div className=" input-group-text">Email</div>
                                    </div>
                                    <input ref={this.emailInput} type="text" disabled={this.state.submitting}
                                           onChange={(e) => this.handleEmailChange(e.target.value)}
                                           className=" form-control"/>

                                </div>
                                {this.state.validEmail ? null : <span>Please Enter a valid email address</span>}
                            </div>
                        </div>
                        <div className=" form-row d-flex justify-content-center">
                            <div className=" form-group col-md-10">
                                <div className=" input-group mb-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Question</div>
                                    </div>
                                    <select disabled={this.state.submitting}
                                            onChange={(e) => this.handleQustionSelection(e)}
                                            className=" form-control">
                                        <option value="">Without this coupon I would have...</option>
                                        {this.state.questions.map((q) => <option key={q.id}
                                                                                 value={q.id}>{q.question}</option>)}

                                    </select>
                                </div>

                            </div>


                        </div>
                        <div className="col-12  text-center">
                            <button disabled={this.state.submitting} style={{backgroundColor: "#074973"}} type=" button"
                                    className=" btn btn-primary mb-3"
                                    onClick={e => {
                                        e.preventDefault();
                                        if (!this.state.validEmail || this.emailInput.current.value === '') {
                                            alert("Please enter a valid E-mail address");
                                            return
                                        }
                                        if (!this.state.validZip || this.zipInput.current.value === '') {
                                            alert("Please enter a valid Zip Code");
                                            return
                                        }
                                        if (this.state.questionSelection === '') {
                                            alert("Please answer the survey question");
                                            return
                                        }
                                        this.submit()
                                    }}>Submit
                            </button>
                        </div>
                    </form> : null}
                {this.state.errorMessage !== '' ?
                    <div className="row errorMessage != ''">
                        < div className="col-12 text-center">{this.state.errorMessage}</div>
                        <div className="col text-center ">
                            <button style={{backgroundColor: "#074973"}} type="button" className="btn btn-primary my-3"
                                    onClick={this.goBack}> Go Back
                            </button>
                        </div>
                        <div className="col text-center">
                            <button style={{backgroundColor: "#074973"}} type="button" className="btn btn-primary my-3"
                                    onClick={this.resend}> Resend
                                Email
                            </button>
                        </div>


                    </div> : null}
            </div>
        );
    }
}

let domContainer = document.querySelector('#parkingcouponform');

if (!(domContainer === undefined || domContainer === null) === true) ReactDOM.render(
    <CouponForm/>, domContainer);